import './PricesPage.scss';

import React from 'react';
import { connect } from "react-redux";
import { routerActions } from "react-router-redux";
import update from 'immutability-helper';
import moment from 'moment';

import { getPrices, putPrices, setPrices } from "./store/actions";
import { formatDollarAmount } from 'utils/data';

import Button from 'components/Button';
import ConfirmModal from 'components/Modal/ConfirmModal';
import LoadingCircle from 'components/LoadingCircle';
import PageContent from 'components/PageContent';
import Textbox from 'components/Textbox';

class PricesPage extends React.Component {
    constructor() {
        super();

        this.state = {
            showConfirmModal: false
        };
    }

    componentWillMount() {
        document.body.classList.add('prices-page');

        this.props.getPrices();

        this.columns = [
            {
                text: '',
                name: 'wasCopiedForward'
            }, {
                text: 'Display Date',
                name: 'displayDate'
            },{
                text: 'Week Ending',
                name: 'weekEnding'
            }, {
                text: 'Report Date',
                name: 'reportDate'
            }, {
                text: 'USDA Class III Value',
                name: 'price'
            }, {
                text: 'Override Class III Value',
                name: 'overrideValue'
            }
        ];
    }

    componentWillUnmount() {
        document.body.classList.remove('prices-page');
    }

    _handleChange(event) {
        console.log(event.target.name)
        let index = event.target.name.split('|')[1];
        let value = event.target.value;

        let newPricesArray = update(this.props.prices.all, {});
        newPricesArray[index].manuallyEnteredPrice = value;
        this.props.setPrices(newPricesArray);
    }

    _handleSave() {
        this.props.putPrices()
            .then((res) => {
                if(res.code === 200) {
                    this.setState({showConfirmModal: true});
                }
            })
    }

    render() {
        return (
            <PageContent>
                <div className="prices">
                    {this.props.prices.isFetching === true ? (
                        <LoadingCircle />
                    ) : (
                        <div className="prices__list--wrapper">
                            <table className="prices-table">
                                <thead>
                                <tr>
                                    {this.columns.map((col, index) => {
                                        return (
                                            <th className="users-table__heading"
                                                key={index}>
                                                {col.text}
                                            </th>
                                        )
                                    })}
                                </tr>
                                </thead>
                                <tbody>
                                    {this.props.prices.all.map((price, priceIndex) => {
                                        return (
                                            <tr key={price.id}>
                                                {this.columns.map((col, index) => {
                                                    if(col.name === 'displayDate') {
                                                        return (
                                                            <td key={index}>
                                                                {moment(price.priceMonth).format('M/D/YY')}
                                                            </td>
                                                        );
                                                    } else if(col.name === 'weekEnding') {
                                                        return (
                                                            <td key={index}>
                                                                {moment(price.weekEnding).format('M/D/YY')}
                                                            </td>
                                                        );
                                                    } else if(col.name === 'reportDate') {
                                                        return (
                                                            <td key={index}>
                                                                {moment(price.reportDate).format('M/D/YY')}
                                                            </td>
                                                        );
                                                    } else if(col.name === 'price') {
                                                        return (
                                                            <td key={index}>
                                                                {formatDollarAmount(price.price)}

                                                            </td>
                                                        );
                                                    } else if(col.name === 'wasCopiedForward') {
                                                        return (
                                                            <td className="admin-check-cell" key={index}>
                                                                {price.wasCopiedForward === true ? (
                                                                    <svg className="admin-check" viewBox="0 0 28 28">
                                                                        <path d="M26.109 8.844c0 0.391-0.156 0.781-0.438 1.062l-13.438 13.438c-0.281 0.281-0.672 0.438-1.062 0.438s-0.781-0.156-1.062-0.438l-7.781-7.781c-0.281-0.281-0.438-0.672-0.438-1.062s0.156-0.781 0.438-1.062l2.125-2.125c0.281-0.281 0.672-0.438 1.062-0.438s0.781 0.156 1.062 0.438l4.594 4.609 10.25-10.266c0.281-0.281 0.672-0.438 1.062-0.438s0.781 0.156 1.062 0.438l2.125 2.125c0.281 0.281 0.438 0.672 0.438 1.062z" />
                                                                    </svg>
                                                                ) : ''}
                                                            </td>
                                                        );
                                                    } else {
                                                        return (
                                                            <td className="prices__override-price-cell">
                                                                <Textbox
                                                                    onChange={this._handleChange.bind(this)}
                                                                    name={`override|${priceIndex}`}
                                                                    type="number"
                                                                    value={price.manuallyEnteredPrice}
                                                                />
                                                            </td>
                                                        );
                                                    }
                                                })}
                                            </tr>
                                        );
                                    })}
                                    <tr>
                                        <td colspan="5" />

                                        <td>
                                            <Button className="prices__save-button"
                                                    disabled={this.props.prices.isSaving === true}
                                                    onClick={this._handleSave.bind(this)}>
                                                Save All

                                                {this.props.prices.isSaving === true ? <LoadingCircle outerColor="#ffffff" /> : null}
                                            </Button>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>

                            <div className="admin-check-instructions">
                                <svg className="admin-check" viewBox="0 0 28 28">
                                    <path d="M26.109 8.844c0 0.391-0.156 0.781-0.438 1.062l-13.438 13.438c-0.281 0.281-0.672 0.438-1.062 0.438s-0.781-0.156-1.062-0.438l-7.781-7.781c-0.281-0.281-0.438-0.672-0.438-1.062s0.156-0.781 0.438-1.062l2.125-2.125c0.281-0.281 0.672-0.438 1.062-0.438s0.781 0.156 1.062 0.438l4.594 4.609 10.25-10.266c0.281-0.281 0.672-0.438 1.062-0.438s0.781 0.156 1.062 0.438l2.125 2.125c0.281 0.281 0.438 0.672 0.438 1.062z" />
                                </svg> marks a value copied forward.
                            </div>
                        </div>
                    )}

                    <ConfirmModal
                        confirmOnClick={() => this.setState({showConfirmModal: false})}
                        confirmText="OK"
                        contentLabel="Modal confirming your changes were saved"
                        show={this.state.showConfirmModal}
                        showDeclineButton={false}
                        title="Your override prices were successfully saved"
                    />
                </div>
            </PageContent>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        prices: state.prices
    }
};

const mapDispatchToProps = (dispatch) => {
    return {
        changeLocation: (path) => dispatch(routerActions.push(path)),
        getPrices: () => dispatch(getPrices()),
        putPrices: () => dispatch(putPrices()),
        setPrices: (pricesArray) => dispatch(setPrices(pricesArray))
    }
};

export default connect(mapStateToProps, mapDispatchToProps)(PricesPage);



// WEBPACK FOOTER //
// ./src/containers/PricesPage/index.js